import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { supportedPublicLanguages } from 'academy-common-lib/constants/academySupportedLanguages';
import UIList from 'UIComponents/list/UIList';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import { ThemedDropdown } from '../../../components/ThemedComponents';
import UILink from 'UIComponents/link/UILink';
import { theme } from 'academy-common-lib/utils/Styling';
import { useMemo } from 'react';
import { getPublicLang, getPublicUrlLanguageVariant } from 'academy-common-lib/utils/url';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicLanguageDropdown = ({
  options = supportedPublicLanguages,
  href = window.location.href
}) => {
  const appLanguage = getPublicLang();
  const sortedLanguages = useMemo(() => [...options].sort(), [options]);
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      color: theme.colors.EERIE,
      name: "language",
      size: "xs",
      style: {
        marginBottom: -7
      }
    }), /*#__PURE__*/_jsx(ThemedDropdown, {
      buttonText: LanguageNames[appLanguage],
      buttonUse: "transparent",
      children: /*#__PURE__*/_jsx(UIList, {
        children: sortedLanguages.map(language => /*#__PURE__*/_jsx(UILink, {
          href: getPublicUrlLanguageVariant(href, language),
          children: LanguageNames[language]
        }, language))
      })
    })]
  });
};
export default PublicLanguageDropdown;